import React, {useEffect, useState} from 'react';
import {Card, Rate, Tag} from "antd";
import dayjs from "dayjs";
import {BiPrinter} from "react-icons/bi";
import ZakazStore from "../../store/zakaz-store";
import BackServer from "../../api/BackServer";
import ReviewDetail from "../reviewDetail/reviewDetail";

const ReviewOne = (props) => {
    return (
        <>
            {Object.entries(props.dta.reviews)
                .map(([key, value]) => (
                    <div key={`review-${key}-${value.uuid}`}>
                        <Card type="inner" title={
                            <>
                                {(value.orderDeliveryType === "REVIEW_ORDER_DELIVERY_CANCELED") ? (
                                    <Tag color="red-inverse">
                                        {dayjs(value.published_at).format("DD.MM.YYYY")}
                                    </Tag>
                                ) : (
                                    <Tag color="green-inverse">
                                        {dayjs(value.published_at).format("DD.MM.YYYY")}
                                    </Tag>
                                )}
                                : {value.product.offer_id} 
                                <a href={value.product.url} target="_blank" rel="noopener noreferrer">
                                    {value.product.title}
                                </a>
                            </>
                        } extra={
                            <Rate disabled defaultValue={value.rating} allowHalf/>
                        }>
                            {(value.photos_count < 1) ? (
                                <div>
                                    <span style={{fontSize: '17px'}}>Количество фото: </span>
                                    <Tag color="red-inverse">Нет</Tag>
                                </div>
                            ) : (
                                <div>
                                    <span style={{fontSize: '17px'}}>Количество фото: </span>
                                    <Tag color="green-inverse">{value.photos_count}</Tag>
                                </div>
                            )}

                            {(value.videos_count < 1) ? (
                                <div>
                                    <span style={{fontSize: '17px'}}>Количество видео: </span>
                                    <Tag color="red-inverse">Нет</Tag>
                                </div>
                            ) : (
                                <div>
                                    <span style={{fontSize: '17px'}}>Количество видео: </span>
                                    <Tag color="green-inverse">{value.videos_count}</Tag>
                                </div>
                            )}

                            <p style={{fontSize: '17px'}}>
                                <Tag style={{fontSize: '17px'}} color="green">Плюсы:</Tag> 
                                {value.text.positive}
                            </p>
                            <p style={{fontSize: '17px'}}>
                                <Tag style={{fontSize: '17px'}} color="red">Минусы:</Tag> 
                                {value.text.negative}
                            </p>

                            <ReviewDetail dta={value}/>
                        </Card>
                    </div>
                ))}
        </>
    );
};

export default ReviewOne;